import axios, { type AxiosError, type InternalAxiosRequestConfig } from 'axios'

type FallbackRequestConfig = InternalAxiosRequestConfig & {
  userOptionsFallbackAttempted?: boolean
}

export function installUserOptionsFallback(): void {
  axios.interceptors.response.use(undefined, async (error: AxiosError) => {
    const config = error.config as FallbackRequestConfig | undefined
    const optionsPath = '/api/users/options/'

    if (
      error.response?.status !== 404
      || config?.method?.toLowerCase() !== 'get'
      || !config.url?.includes(optionsPath)
      || config.userOptionsFallbackAttempted
    ) {
      throw error
    }

    config.userOptionsFallbackAttempted = true
    config.url = config.url.replace(optionsPath, '/api/users/')
    return axios.request(config)
  })
}
